import { createFileRoute } from '@tanstack/react-router';
import { CompaniesPage } from '@/features/companies/CompaniesPage';

interface CompaniesSearchParams {
  page?: number;
  pageSize?: number;
  search?: string;
  categories?: string;
  sortBy?: string;
  sortOrder?: 'asc' | 'desc';
}

export const Route = createFileRoute('/_app/companies')({
  component: CompaniesPage,
  validateSearch: (search: Record<string, unknown>): CompaniesSearchParams => {
    return {
      page: search.page ? Number(search.page) : undefined,
      pageSize: search.pageSize ? Number(search.pageSize) : undefined,
      search: search.search as string | undefined,
      categories: search.categories as string | undefined,
      sortBy: search.sortBy as string | undefined,
      sortOrder: search.sortOrder as 'asc' | 'desc' | undefined,
    };
  },
});
